<nz-select [(ngModel)]="selected" (nzOnSearch)="search($event)" (ngModelChange)="onModelChanged($event)" [nzDisabled]="isDisabled" [nzMode]="hxMode"
           nzPlaceHolder="Выберите банк" [nzDropdownMatchSelectWidth]="false" nzAllowClear nzShowSearch>
  <nz-option *ngFor="let op of options" [nzLabel]="op.name" [nzValue]="op.id"></nz-option>
</nz-select>
